import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/core/services/user.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { MarketplacesService } from 'src/app/core/services/marketplaces.service';
import { Subscription } from 'rxjs';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { SaleOrderCreateTemplatePopupComponent } from './so-create-template-popup/so-create-template-popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SaleOrderTemplateService } from 'src/app/core/services/so-template.service';
import { Roles } from 'src/app/shared/enums/role-types.enum';

@Component({
    selector: 'eci-so-marketplace-templates',
    templateUrl: './so-marketplace-templates.component.html',
    styleUrls: ['./so-marketplace-templates.component.scss']
})
export class SaleOrderMarketplaceTemplatesComponent implements OnInit {

    sub$: Subscription = new Subscription();
    listOfMarketplaces: any;
    listOfMarketplacesWithTemplates: any[] = [];
    listOfMarketplacesWithoutTemplates: any[] = [];
    showLoader: boolean = false;
    searchorMarketplaces: FormControl = new FormControl();
    marketplaces: FormControl = new FormControl();

    listOfTemplates: any[] = [];

    dataSource: MatTableDataSource<any>;
    displayedColumns = [
        'marketplaceName',
        'date',
        'delete'
    ];

    get isDelegateAdmin(): boolean {
        return this.userSvc.userStorage.role == Roles.DelicateAdmin;
    }

    constructor(
        public localStorageSvc: LocalStorageService,
        public userSvc: UserService,
        private marketplaceSvc: MarketplacesService,
        private dialog: MatDialog,
        private router: Router,
        private route: ActivatedRoute,
        private soTemplateSvc: SaleOrderTemplateService,
    ) {
    }

    ngOnInit() {
        this.sub$.add(
            this.marketplaceSvc.availableMarketplaces$.subscribe(res => {
                this.listOfMarketplaces = res;
                this.getTemplates();
            })
        );

    }

    search(): void {
        this.soTemplateSvc.getAllTemplates(this.marketplaces.value).subscribe(res => {
            this.listOfTemplates = res;
            this.dataSource = new MatTableDataSource(this.listOfTemplates);
        })
    }

    getTemplates(): void {
        this.sub$.add(
            this.soTemplateSvc.getAllTemplates().subscribe(res => {
                this.listOfTemplates = res;
                this.dataSource = new MatTableDataSource(this.listOfTemplates);

                let templateMarketplaceIds = this.listOfTemplates.map(el => {
                    return el.marketplaceId;
                });
                this.listOfMarketplacesWithTemplates = this.listOfMarketplaces.filter(fil =>
                    templateMarketplaceIds.includes(fil.id)
                );
                this.listOfMarketplacesWithoutTemplates = this.listOfMarketplaces.filter(el =>
                    !templateMarketplaceIds.includes(el.id)
                );
            })
        );
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(SaleOrderCreateTemplatePopupComponent);
        dialogRef.componentInstance.listOfMarketplaces = this.listOfMarketplacesWithoutTemplates;

        dialogRef.afterClosed().subscribe(res => {
            if (!res) {
                return;
            }
            this.router.navigate(['details', { marketplaceId: res }], { relativeTo: this.route });
        });
    }

    delete(id: number): void {
        this.soTemplateSvc.delete(id).subscribe(res => {
            this.getTemplates();
        });
    }

    navigateTo(id: number): void {
        this.router.navigate([`details/${id}`], { relativeTo: this.route });
    }
}
